import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d63vhe5anburc340qmgg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-teal-600 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-1">
              <img 
                src="https://static.readdy.ai/image/7012d1ed0225cfc4bba0161dc27b2468/492a50073aefd787718d6c2300220c9a.png" 
                alt="Burtman's Painting" 
                className="h-16 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-white text-sm leading-relaxed">
                Professional painting & landscape services serving Missouri communities since 2023.
              </p>
            </div>

            <div>
              <h3 className="text-white text-base font-bold mb-4">Quick Links</h3>
              <ul className="space-y-3">
                <li>
                  <button onClick={() => scrollToSection('home')} className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                    Home
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('about')} className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                    About Us
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                    Services
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('gallery')} className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                    Gallery
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('contact')} className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer">
                    Contact
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-white text-base font-bold mb-4">Follow Us</h3>
              <ul className="space-y-3">
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61583260346277" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white text-sm transition-colors flex items-center space-x-2 cursor-pointer">
                    <i className="ri-facebook-line text-lg"></i>
                    <span>Facebook</span>
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-white text-base font-bold mb-4">Newsletter</h3>
              <p className="text-white/80 text-sm mb-4">
                Stay updated with seasonal tips and special offers
              </p>
              <form id="newsletter-form" data-readdy-form onSubmit={handleNewsletterSubmit} className="flex">
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 px-4 py-2 rounded-l-full text-sm focus:outline-none"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors -ml-10 cursor-pointer disabled:bg-gray-300"
                >
                  <i className="ri-arrow-right-line text-teal-600 text-lg"></i>
                </button>
              </form>
              {submitStatus === 'success' && (
                <p className="text-white text-xs mt-2">Thanks for subscribing!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-200 text-xs mt-2">Something went wrong. Try again.</p>
              )}
            </div>
          </div>

          <div className="border-t border-white/20 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between text-white/80 text-sm">
              <p>&copy; 2024 Burtman's Painting & Landscape. All rights reserved.</p>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors mt-4 md:mt-0 cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 text-center opacity-5 pointer-events-none">
            <p className="text-white text-9xl font-bold">BURTMAN'S</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
